<app-dashboard-stats-card [title]="'Requested'" subtitle="Packages that have been 'Requested' by a provider."
                          [count]="getPackageCount()" [routerLink]="'/my-packages'" [queryParams]="{ open: true, open_o: 'is', requested: true, requested_o: 'is' }" />
